import { yupResolver } from '@hookform/resolvers/yup';
import Image from 'next/image';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import type {
  BankDetailsType,
  UserAddBankType,
} from '@/api/digital-gold/bank-details/addBank';
import { useAddBank } from '@/api/digital-gold/bank-details/addBank';
import closeIcon from '@/assets/images/icons/close-icon.svg';

type BankForm = {
  accountHolderName: string;
  accountNumber: string;
  confirmAccount: string;
  ifscCode: string;
  verified: boolean;
};

export const AddBankModal = (props: any) => {
  const { closeBankModal, bankModalRef, userId } = props;
  const accountRegEx: RegExp = /[0-9]{9,18}/;
  const ifscRegEx: RegExp = /^[A-Z]{4}[0][A-Z0-9]{6}$/;
  const bankSchema: any = yup.object({
    accountHolderName: yup.string().required('*Required'),
    accountNumber: yup
      .string()
      .required('*Required')
      .matches(accountRegEx, 'Enter valid Account Number'),
    confirmAccount: yup
      .string()
      .required('*Required')
      .when('accountNumber', {
        is: (accountNumber: String) => accountNumber.length !== 0,
        then: (x) =>
          x.oneOf(
            [yup.ref('accountNumber')],
            'Should be same as Account Number'
          ),
      }),
    ifscCode: yup
      .string()
      .required('*Required')
      .matches(ifscRegEx, 'Enter valid IFSC Code'),
    verified: yup.bool().oneOf([true], 'Please Check the verify box'),
  });
  const {
    register: bankAccount,
    handleSubmit: handleSubmitBankDetails,
    formState: { errors: accountErrors },
    reset: bankFormReset,
  } = useForm<BankForm>({
    defaultValues: {
      accountHolderName: '',
      accountNumber: '',
      confirmAccount: '',
      ifscCode: '',
      verified: false,
    },
    resolver: yupResolver(bankSchema),
  });
  const addBankFn = useAddBank();
  const onBankDetailsSubmit = async (data: BankForm) => {
    const bankData: BankDetailsType = {
      accountNumber: data.accountNumber,
      accountHolderName: data.accountHolderName,
      ifscCode: data.ifscCode,
      isDgFlow: true,
    };
    const payLoadData: UserAddBankType = {
      data: bankData,
      id: userId.id,
    };

    const addBankStatus = await addBankFn.mutateAsync(payLoadData);
    if (addBankStatus?.status === 200) {
      closeBankModal();
      bankFormReset();
    }
  };
  return (
    <div
      className={`modal loanDetails__modal addressDetail__modal fade `}
      id="bankPop"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="bankPopLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal__title">
            <p className="text--semi text--black sell_p">Add Account Details</p>
            <a data-dismiss="modal" ref={bankModalRef}>
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={closeIcon}
                alt="close icon"
              />
            </a>
          </div>
          <div className="interestDetail topup">
            <form
              autoComplete="off"
              onSubmit={handleSubmitBankDetails(onBankDetailsSubmit)}
            >
              <div className="form-row">
                <div className="form-group col">
                  <div className="input-container">
                    <label
                      className="text--regular text--black"
                      htmlFor="hoName"
                    >
                      Account Holder Name
                    </label>
                    <div className="input-form">
                      <input
                        maxLength={30}
                        type="text"
                        placeholder="Radha Shrivastava"
                        id="hoName"
                        {...bankAccount('accountHolderName')}
                      />
                    </div>
                    {/* <p className="text--gray text--regular errorMessage withInfo sell_p">
                      Account Holder Name should match the KYC documents
                    </p> */}
                    {accountErrors.accountHolderName && (
                      <p className="text--red sell_p">
                        {accountErrors?.accountHolderName.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col">
                  <div className="input-container">
                    <label
                      className="text--regular text--black"
                      htmlFor="acNumber"
                    >
                      Account Number
                    </label>
                    <div className="input-form">
                      <input
                        type="number"
                        placeholder="1234 1234 1234 1234"
                        id="acNumber"
                        {...bankAccount('accountNumber')}
                      />
                    </div>
                    {accountErrors.accountNumber && (
                      <p className="text--red sell_p">
                        {accountErrors.accountNumber.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col">
                  <div className="input-container">
                    <label
                      className="text--regular text--black"
                      htmlFor="reAcNumber"
                    >
                      Re-Enter Account Number
                    </label>
                    <div className="input-form">
                      <input
                        type="number"
                        placeholder="Re-Enter Account Number"
                        id="reAcNumber"
                        {...bankAccount('confirmAccount')}
                      />
                    </div>
                    {accountErrors.confirmAccount && (
                      <p className="text--red sell_p">
                        {accountErrors?.confirmAccount.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col">
                  <div className="input-container">
                    <label className="text--regular text--black" htmlFor="ifsc">
                      IFSC Code
                    </label>
                    <div className="input-form">
                      <input
                        type="text"
                        placeholder="Your IFSC Code"
                        id="ifsc"
                        {...bankAccount('ifscCode')}
                      />
                    </div>

                    {accountErrors.ifscCode && (
                      <p className="text--red sell_p">
                        {accountErrors?.ifscCode.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col">
                  <label className="custom__checkbox">
                    <input type="checkbox" {...bankAccount('verified')} />
                    <span className="custom__checkbox__checkmark"></span>
                    <p className="text--black text--regular checkText sell_p">
                      Verify this account by making a ₹1 transaction
                    </p>
                  </label>
                  {accountErrors.verified && (
                    <p className="text--red sell_p">
                      {accountErrors?.verified.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="action-container mt-0">
                <button
                  className="custom__button custom__button--dark border-btn backBtn text--bold w-100 mr-md-2 ml-0"
                  data-dismiss="modal"
                  type="button"
                  id="DG_bank-close"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="custom__button custom__button--dark text--semi w-100 ml-0"
                  id="DG_bank-verify"
                >
                  Verify & Add
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
